import { DynamicLabradorJwVideoArticle } from '@/components/labrador/JwVideo/Article';
import { DynamicLabradorJwVideoTeaser } from '@/components/labrador/JwVideo/Teaser';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorJwVideo: LabradorComponent = ({ data, type, meta, descendants }) => {
  const { enableShop, enableTeaser } = data;
  if (enableShop) return null;

  if (enableTeaser)
    return (
      <DynamicLabradorJwVideoTeaser
        data={data}
        type={type}
        meta={meta}
        descendants={descendants}
        {...withDebugMetadata({ type, meta })}
      />
    );

  return (
    <DynamicLabradorJwVideoArticle
      data={data}
      type={type}
      meta={meta}
      descendants={descendants}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorJwVideo;
